import { render, staticRenderFns } from "./ModalsTemplate.vue?vue&type=template&id=417ae8b1"
import script from "./ModalsTemplate.vue?vue&type=script&lang=js"
export * from "./ModalsTemplate.vue?vue&type=script&lang=js"
import style0 from "./ModalsTemplate.vue?vue&type=style&index=0&id=417ae8b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports